import { render, staticRenderFns } from "./fccSexo.vue?vue&type=template&id=270d5402"
import script from "./fccSexo.vue?vue&type=script&lang=js"
export * from "./fccSexo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports